import { useState, useEffect } from 'react';
import { logger } from '@/services/LoggingService';
import { getIsSizeLocked, updatePortfolioFields } from '@/services/portfolio/PortfolioService';

export const usePortfolioSizeLock = (portfolioId: string) => {
  const [isPortfolioSizeLocked, setIsPortfolioSizeLocked] = useState(false); // Default to unlocked

  useEffect(() => {
    if (!portfolioId) return;
    
    // Load lock state from database (is_size_locked field)
    const loadLockState = async () => {
      try {
        const dbLockState = await getIsSizeLocked(portfolioId);
        logger.debug('usePortfolioSizeLock', 'Loaded lock state from database', {
          portfolioId,
          dbLockState,
          currentState: isPortfolioSizeLocked
        });
        setIsPortfolioSizeLocked(dbLockState);
      } catch (error) {
        logger.error('usePortfolioSizeLock', 'Failed to load portfolio lock state', { error, portfolioId });
      }
    };

    loadLockState();
  }, [portfolioId]);

  const togglePortfolioSizeLock = async () => {
    const newValue = !isPortfolioSizeLocked;
    
    logger.debug('usePortfolioSizeLock', 'Toggling lock state', {
      portfolioId,
      oldValue: isPortfolioSizeLocked,
      newValue
    });
    
    try {
      // Update database first
      await updatePortfolioFields(portfolioId, { is_size_locked: newValue } as any);

      // Update local state only after successful database update
      setIsPortfolioSizeLocked(newValue);
      
      logger.debug('usePortfolioSizeLock', 'Lock state updated successfully', {
        portfolioId,
        newValue
      });
    } catch (error) {
      logger.error('usePortfolioSizeLock', 'Error updating portfolio lock state', { error, portfolioId });
    }
  };

  return {
    isPortfolioSizeLocked,
    togglePortfolioSizeLock,
  };
};
